import { useTranslation } from '../../store/context/TranslationContext';

/**
 * This component is used to show the previous value of a field.
 * Recieve 2 props: value -> previous value, show -> boolean to show the component is previous value exists.
 */
const PreviousValue = ({ value, show, testId }) => {
    const { t } = useTranslation();
    if (!show) return null;
    return (
        <div className='text-decoration-line-through fv__field-old-value' data-testid={testId}>
            {t(value)}
        </div>
    )
}

export default PreviousValue;
